import { SVGProps } from "react"

import { TablerIcon } from "~/src/sink"

export const ChevronDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <TablerIcon {...props}>
    <path d="m6 9 6 6 6-6" />
  </TablerIcon>
)
